import React, {forwardRef} from 'react';
import {SpecialistSearchResultDto} from "../../core/models/interfaces/specialists-search-result-dto.interface";
import PublicSpecialistCard from "./public-specialist-card";
import AppButton from "@common/components/app-button";
import {XMarkIcon} from "@heroicons/react/20/solid";

interface PublicRecommendedSpecialistsProps {
    specialists: SpecialistSearchResultDto[];
    onClose?: () => void;
}

const PublicRecommendedSpecialists = forwardRef<HTMLDivElement, PublicRecommendedSpecialistsProps>(({specialists, onClose}, ref) => {
    if (!specialists || specialists.length === 0) return null;
    return (
        <div className="mt-4 space-y-6" ref={ref} id="recommended-specialists">
            <div className="flex items-center justify-between">
                <h2 className="text-2xl font-semibold leading-[30px]">Polecani specjaliści</h2>
                {onClose && (
                    <AppButton
                        onClick={onClose}
                        className="hidden lg:flex bg-white hover:bg-on-surface/5 border border-outline-mild rounded-full h-[36px] px-3 w-fit"
                    >
                        <div className="flex items-center gap-2">
                            <XMarkIcon className="w-5 h-5"/>
                            <span className="font-semibold text-sm">Schowaj</span>
                        </div>
                    </AppButton>
                )}
            </div>
            <div className="flex flex-col gap-6">
                {specialists.map((s) => (
                    <PublicSpecialistCard key={s.id} specialist={s}/>
                ))}
            </div>
        </div>
    );
});

export default PublicRecommendedSpecialists;


